<pre class="text-center" i18n>Version: {{ version }}</pre>
